import { FC } from 'react';
import { OrderItem } from '@mews-commander/types';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedNumber } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import OrderItemName from './OrderItemName';

interface ExtendedOrderItemNameProps {
    orderItem: OrderItem;
}

export const ExtendedOrderItemName: FC<ExtendedOrderItemNameProps> = ({ orderItem }) => (
    <Stack spacing="100">
        <OrderItemName orderItem={orderItem} />
        {orderItem.nightMultiplier > 1 ? (
            <>
                <span>{UnicodeEntity.MultiplicationSign}</span>
                <LocalizedNumber number={orderItem.nightMultiplier} />
            </>
        ) : null}
        {orderItem.personMultiplier > 1 ? (
            <>
                <span>{UnicodeEntity.MultiplicationSign}</span>
                <LocalizedNumber number={orderItem.personMultiplier} />
            </>
        ) : null}
        <span>{UnicodeEntity.Pipe}</span>
        <LocalizedDateFromUtc utcString={orderItem.consumedUtc} />
    </Stack>
);
